<template>
  <div class="radish-left" v-if="isShow">
    <div class="radish-head">
      <div class="radish-title">人才画像</div>
      <div class="radish-btns">
        <div class="radish-btn radish-btn-primary" @click="doDownload">保存图片</div>
        <div class="radish-btn" @click="close">关闭</div>
      </div>
    </div>
    <div class="radish-body">
      <div class="portrait">
        <div v-if="project" class="portrait-item">
          <div class="portrait-title">岗位匹配度</div>
          <div class="portrait-content">
            <div class="content-item">
              <span class="portrait-label">专业匹配度：</span>
              <span class="portrait-tag">{{ portraitData['专业匹配度'] }}</span>
            </div>
            <div class="content-item">
              <span class="portrait-label">素质要求匹配度：</span>
              <span class="portrait-tag">{{ portraitData['素质要求匹配度'] }}</span>
            </div>
            <div v-if="portraitData['专业度']" class="content-item">
              <span class="portrait-label">专业度：</span>
              <span class="portrait-tag">{{ portraitData['专业度'] }}</span>
            </div>
            <div>
              <div class="portrait-label">关键标签：</div>
              <el-tag v-for="(tag, k) in portraitData['关键标签']" :key="k" size="mini" style="margin:3px">{{
                tag
              }}</el-tag>
            </div>
          </div>
        </div>
        <div v-else class="portrait-item">
          <div class="portrait-title">关键标签</div>
          <div class="portrait-content">
            <div v-if="portraitData['专业度']">
              <span class="portrait-label">专业度：</span>
              <span class="portrait-tag">{{ portraitData['专业度'] }}</span>
            </div>
            <div v-if="portraitData['关键标签'].length > 0">
              <span class="portrait-label">关键标签：</span>
              <span class="portrait-tag" v-for="(tag, k) in portraitData['关键标签']" :key="k">{{ tag }}</span>
            </div>
            <div v-if="portraitData['软性标签'].length > 0">
              <span class="portrait-label">软性标签：</span>
              <span class="portrait-tag" v-for="(tag, k) in portraitData['软性标签']" :key="k">{{ tag }}</span>
            </div>
            <div v-if="portraitData['学历标签'].length > 0">
              <span class="portrait-label">学历标签：</span>
              <span class="portrait-tag" v-for="(tag, k) in portraitData['学历标签']" :key="k">{{ tag }}</span>
            </div>
          </div>
        </div>
        <div class="portrait-item">
          <div class="portrait-title">离职动机及意愿度</div>
          <div class="portrait-content">
            <div>
              <div class="portrait-label">动机：{{ portraitData['动机'] }}</div>
              <div id="pie-dom" style="height:300px"></div>
            </div>
            <div>
              <div class="content-item">
                <div>
                  <span class="portrait-label">离职意愿度：</span>
                  <span class="portrait-tag">{{ portraitData['离职意愿度'] }}</span>
                </div>
                <div>
                  <el-input type="textarea" placeholder="离职意愿度描述" v-model="portraitData['离职意愿度描述']">
                  </el-input>
                </div>
              </div>
              <div class="content-item">
                <div class="portrait-label">风险预测：</div>
                <div>
                  <el-input type="textarea" placeholder="风险预测" v-model="portraitData['风险预测']"> </el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="portrait-item">
          <div class="portrait-title">谈判要点（人选诉求）</div>
          <div class="portrait-content">
            <div class="portrait-label">{{ portraitData['人选诉求'] }}</div>
            <div id="bar-dom" style="height:300px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import htmlToImage from 'html-to-image'
const download = require('downloadjs')
const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/bar')
const hasIntersection = (arr1, arr2) => {
  if (arr1.length === 0 || arr2.length === 0) {
    return false
  }
  let res = []
  arr2.forEach(a => {
    if (arr1.includes(a)) {
      res.push(a)
    }
  })
  if (res.length > 0) {
    return res
  }
  return false
}
// const formatter = (str, len) => {
//   let arr = str.split('')
//   let res = ''
//   for (let i = 0; i < arr.length; i++) {
//     const s = arr[i]
//     res += s
//     if (!(i % len)) res += '\n'
//   }
//   return res
// }
export default {
  data: function() {
    return {
      isShow: false,
      portraitData: {
        专业匹配度: '请完善项目信息',
        素质要求匹配度: '请完善项目信息',
        专业度: '',
        离职意愿度: '',
        离职意愿度描述: '',
        关键标签: [],
        软性标签: [],
        学历标签: [],
        动机: '请完善沟通信息',
        人选诉求: '请完善沟通信息',
        风险预测: '',
      },
      project: null,
    }
  },
  methods: {
    async open(params) {
      const { rid, project } = params
      if (project) this.project = project
      // 获取人选
      const radRes = await app.service('radish').simpleFetch({
        _id: rid,
        fields: {
          姓名: 1,
          公司: 1,
          职能模块: 1,
          平台: 1,
          职级: 1,
          业绩: 1,
          长期意向: 1,
          行业: 1,
          地域: 1,
          细分职能: 1,
          离职意愿度: 1,
          学历标签: 1,
        },
      })
      if (radRes.status == 'fail') {
        this.$message.error(radRes.msg)
        return
      } else if (radRes.msg == 'nothave') {
        this.$message.warning('人选不存在')
        return
      }
      const radish = radRes.data
      // console.log(radish)
      // console.log(project)
      // 获取情报
      let bulletins = []
      if (radish['公司']) {
        const comRes = await app.service('radish').leaveForecast(radish)
        if (comRes.status == 'success' && comRes.data.length > 0) {
          bulletins = comRes.data.sort((a, b) => {
            const numA = parseInt(a['变动影响程度'].slice(0, 1))
            const numB = parseInt(b['变动影响程度'].slice(0, 1))
            return numB - numA
          })
        }
      }
      // console.log(bulletins)

      // 获取沟通日志
      const communication = await app
        .service('communication')
        .testPaper({ radishId: radish._id, category: radish['职能模块'] })
      // console.log(communication)

      // 重置
      this.portraitData = {
        专业匹配度: '请完善项目信息',
        素质要求匹配度: '请完善项目信息',
        专业度: '',
        离职意愿度: '',
        离职意愿度描述: '',
        关键标签: [],
        软性标签: [],
        学历标签: [],
        动机: '请完善沟通信息',
        人选诉求: '请完善沟通信息',
        风险预测: '',
      }

      // 计算专业度
      if (radish['业绩']) {
        switch (radish['业绩']) {
          case 'aaa':
            this.portraitData['专业度'] = 'AAA卓越人选'
            break
          case 'aa':
            this.portraitData['专业度'] = 'AA卓越人选'
            break
          case 'a':
            this.portraitData['专业度'] = 'A优秀人选'
            break
          default:
            this.portraitData['专业度'] = '一般人选'
            break
        }
      }
      // 计算关键标签
      if (radish['职能模块']) this.portraitData['关键标签'] = this.portraitData['关键标签'].concat(radish['职能模块'])
      if (radish['擅长方向']) this.portraitData['关键标签'] = this.portraitData['关键标签'].concat(radish['擅长方向'])
      if (radish['平台']) {
        switch (radish['平台']) {
          case 'A':
            this.portraitData['关键标签'] = this.portraitData['关键标签'].concat('大平台')
            break
          case 'B':
            this.portraitData['关键标签'] = this.portraitData['关键标签'].concat('中型平台')
            break
        }
      }
      // 计算软性标签
      if (communication && communication.tags && communication.tags.length > 0) {
        let ruan = []
        communication.tags.forEach(c => {
          if (c.checkList) ruan = ruan.concat(c.checkList)
        })
        this.portraitData['软性标签'] = ruan
      }

      // 计算学历标签
      if (radish['学历标签']) this.portraitData['学历标签'] = radish['学历标签']

      if (project) {
        // 获取项目人选评分
        let pingfen = project.pingfen
        if (!pingfen) {
          const fenRes = await app.service('radish').getPingfen({ rid: radish._id, pid: project.pid || project._id })
          if (fenRes.status == 'success' && fenRes.data.pingfen) {
            pingfen = fenRes.data.pingfen
          }
        }
        // console.log(pingfen)
        // 计算专业匹配度
        const fields = ['职能模块', '平台', '职级', '业绩', '长期意向', '行业', '地域', '细分职能']
        const zhiji = {
          '1': '高管',
          '2': '部门总',
          '3': '部门副总/总助/团队长',
          '4': '部门核心骨干',
          '5': '新人三年以下',
        }
        const pingtai = {
          A: '大平台',
          B: '中型平台',
        }
        let numerator = 0
        let denominator = 0
        fields.forEach(field => {
          switch (field) {
            case '职能模块':
              if (project['职能模块']) {
                denominator++
                if (
                  radish['职能模块'] &&
                  radish['职能模块'].length > 0 &&
                  radish['职能模块'].includes(project['职能模块'])
                ) {
                  numerator++
                  this.portraitData['关键标签'].push(project['职能模块'])
                }
              }
              break
            case '平台':
              if (project['平台'] && project['平台'].length > 0) {
                denominator++
                if (radish['平台'] && project['平台'].includes(radish['平台'])) {
                  numerator++
                  if (['A', 'B'].includes(radish['平台'])) {
                    this.portraitData['关键标签'].push(pingtai[radish.平台])
                  }
                }
              }
              break
            case '职级':
              if (project['职级'] && project['职级'].length > 0) {
                denominator++
                if (radish['职级'] && project['职级'].includes(radish['职级'])) {
                  numerator++
                  this.portraitData['关键标签'].push(zhiji[radish.职级])
                }
              }
              break
            case '业绩':
              if (project['业绩'] && project['业绩'].length > 0) {
                denominator++
                if (radish['业绩'] && project['业绩'].includes(radish['业绩'])) {
                  numerator++
                  if (['aaa', 'aa', 'a'].includes(radish['业绩'])) {
                    this.portraitData['关键标签'].push(radish['业绩'])
                  }
                }
              }
              break
            case '长期意向':
              if (radish['长期意向'] && radish['长期意向'] === 'Y') {
                denominator++
                numerator++
                this.portraitData['关键标签'].push('意愿积极')
              }
              break
            case '行业':
              if (
                project['目标行业'] &&
                project['目标行业'].length > 0 &&
                radish['行业'] &&
                project['目标行业'].includes(radish['行业'])
              ) {
                denominator++
                numerator++
                this.portraitData['关键标签'].push(radish['行业'])
              }
              break
            case '地域':
            case '细分职能':
              if (project[field] && project[field].length > 0 && radish[field] && radish[field].length > 0) {
                const intersection = hasIntersection(project[field], radish[field])
                if (intersection) {
                  denominator++
                  numerator++
                  this.portraitData['关键标签'] = this.portraitData['关键标签'].concat(intersection)
                }
              }
              break
            default:
              break
          }
        })
        if (denominator) {
          this.portraitData['专业匹配度'] = ((numerator / denominator) * 100).toFixed(0) + '%'
        }
        // 计算素质要求匹配度
        let numerator2 = 0
        let denominator2 = 0
        if (project['标签'] && project['标签'].length > 0) {
          if (pingfen) {
            project['标签'].forEach(tag => {
              if (pingfen[tag]) {
                denominator2 = denominator2 + 5
                numerator2 = numerator2 + pingfen[tag]
                if (pingfen[tag] > 3) {
                  this.portraitData['关键标签'].push(tag)
                }
              }
            })
            if (denominator) {
              this.portraitData['素质要求匹配度'] = ((numerator2 / denominator2) * 100).toFixed(0) + '%'
            }
          } else {
            this.portraitData['素质要求匹配度'] = '请完善评分信息'
          }
        }
      }
      // 计算离职意愿度
      if (radish['离职意愿度']) {
        if (radish['离职意愿度'] > 80) {
          this.portraitData['离职意愿度'] = '高'
        } else if (radish['离职意愿度'] > 60) {
          this.portraitData['离职意愿度'] = '中'
        } else {
          this.portraitData['离职意愿度'] = '低'
        }
      } else {
        this.portraitData['离职意愿度'] = '未知'
      }
      // 计算离职意愿度描述
      let des = ''
      if (bulletins.length > 0) {
        des = des + bulletins[0]['变动因素'] + '影响，'
      }
      if (radish['长期意向'] === 'Y') {
        des = des + '个人近期关注外部机会'
      } else if (radish['长期意向'] === 'F') {
        des = des + '个人近期有条件考虑外部机会'
      } else {
        des = des + '个人有可能考虑外部机会'
      }
      if (this.portraitData['离职意愿度']) {
        des = des + '，离职意愿度' + this.portraitData['离职意愿度']
      }
      this.portraitData['离职意愿度描述'] = des

      this.$nextTick(() => {
        // 显示
        this.isShow = true
        // 计算动机
        if (
          communication &&
          communication['11'] &&
          communication['11'].answer &&
          communication['11'].answer.length > 1
        ) {
          let answer = communication['11'].answer
          const dt = []
          answer = answer.map((a, k) => {
            a = a.split('，')[0].replace(/\（.*?\）/, '')
            dt.push({ value: (answer.length - k) * 20, name: a })
            return a
          })
          this.portraitData['动机'] = answer.join('>')
          const option11 = {
            series: [
              {
                name: '动机',
                type: 'pie',
                radius: '55%',
                center: ['50%', '50%'],
                data: dt,
                // itemStyle: {
                //   normal: {
                //     label: {
                //       show: true,
                //       formatter: function(val) {
                //         return formatter(val.name, 5)
                //       },
                //     },
                //   },
                // },
              },
            ],
          }
          this.$nextTick(() => {
            const Chart11 = echarts.init(this.$el.querySelector('#pie-dom'))
            Chart11.setOption(option11)
          })
        }
        // 计算人选诉求
        if (communication && communication['7'] && communication['7'].answer) {
          const answer = communication['7'].answer
          this.portraitData['人选诉求'] = answer.join('>')
          const dtx = []
          const dty = []
          answer.forEach((a, k) => {
            dtx.push(a.replace(/\（.*?\）/, ''))
            dty.push((answer.length - k) * 20)
          })
          const option7 = {
            xAxis: {
              type: 'category',
              data: dtx,
              // axisLabel: {
              //   formatter: function(val) {
              //     console.log(val)
              //     return formatter(val, 6)
              //   },
              // },
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                data: dty,
                type: 'bar',
              },
            ],
          }
          this.$nextTick(_ => {
            const Chart7 = echarts.init(this.$el.querySelector('#bar-dom'))
            Chart7.setOption(option7)
          })
        }
      })
    },
    close() {
      this.isShow = false
    },
    doDownload() {
      htmlToImage.toPng(document.getElementById('portrait')).then(function(dataUrl) {
        download(dataUrl, 'portrait.png')
      })
    },
  },
}
</script>
<style>
.portrait {
  background: #fff;
  padding: 5px 10px;
}
.portrait-title {
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  background: #409eff;
  text-align: center;
  color: #fff;
}
.portrait-content {
  padding: 10px;
}
.content-item {
  width: 50%;
  display: inline-block;
  padding: 3px 5px;
}
.portrait-label {
  font-size: 14px;
  font-weight: bold;
}
.portrait-tag {
  display: inline-block;
  padding: 3px 5px;
  margin: 3px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  background: #face8b;
}
</style>
